import { Languages } from '@/components/LanguageSelector/types.ts'
import en from '@/locale/en'
import es from '@/locale/es.ts'
import pt from '@/locale/pt-BR.ts'
import i18next from 'i18next'

export default i18next.init({
  resources: {
    en,
    [Languages.PTBR]: pt,
    es,
  },
  fallbackLng: Languages.PTBR,
  interpolation: {
    escapeValue: false,
  },
})
